import { PlanTypes } from "~/modules/user/store/types";

// // // //

export type WindowType = "daily" | "weekly" | "monthly";

interface PlanDownloadConfig {
    downloadLimit: number;
    window: WindowType;
    scaleBySeats: boolean;
}

export const PLAN_DOWNLOAD_CONFIGS: Record<PlanTypes, PlanDownloadConfig> = {
    [PlanTypes.FREE]: {
        downloadLimit: 1,
        window: "daily",
        scaleBySeats: false,
    },
    // NOTE - PREMIUM_STARTER has the same download limit as "FREE" plan
    [PlanTypes.TRIAL_STARTER]: {
        downloadLimit: 1,
        window: "daily",
        scaleBySeats: false,
    },
    [PlanTypes.TRIAL_ALL_ACCESS]: {
        downloadLimit: Infinity,
        window: "monthly",
        scaleBySeats: false,
    },
    [PlanTypes.TRIAL_DATA_DOWNLOADS]: {
        downloadLimit: 10,
        window: "monthly",
        scaleBySeats: false,
    },
    // NOTE - PREMIUM_STARTER has the same download limit as "FREE" plan
    [PlanTypes.PREMIUM_STARTER]: {
        downloadLimit: 1,
        window: "daily",
        scaleBySeats: false,
    },
    [PlanTypes.PREMIUM_ALL_ACCESS]: {
        downloadLimit: Infinity,
        window: "monthly",
        scaleBySeats: false,
    },
    [PlanTypes.PREMIUM_DATA_DOWNLOADS]: {
        downloadLimit: 30,
        window: "monthly",
        scaleBySeats: true,
    },
    [PlanTypes.PREMIUM_ACADEMIC]: {
        downloadLimit: Infinity,
        window: "monthly",
        scaleBySeats: false,
    },
};
